<template>
  <div class="flex xs12 md12 w-table">
    <vuestic-widget id="dategridPayOrder">
      <div class="va-row">
          <div class="flex md6">
            {{ $t('t.requestLog20') }}
          </div>
          <div class="flex md6 text-right">
            <button class="btn btn-primary btn-sm" id="myBtnWrapper" @click="handleRefresh">
              {{ "basic.button.refresh" | translate }}
            </button>
          </div>
      </div>
      <div class="table-responsive mt-2" id="waybillDownload">
        <table class="table table-striped">
          <thead>
            <tr>
              <th v-for="(item, index) in tableHeaderList" :key="index">
                {{ item.label | translate }}
              </th>
            </tr>
          </thead>
          <tbody v-if="list">
            <tr v-for="(item, index) in list" :key="index">
              <td> {{ item.id }} </td>
              <td>{{ timeZoneValue(item.conditions) }}</td>
              <td> {{ item.create_time }} </td>
              <td> {{ item.update_time }} </td>
              <td> {{ formatDownloadResult(item.result) }} </td>
              <td>
                <a v-if="item.download_url" :href="item.download_url"><i class="el-icon-download"></i>{{ $t('t.download') }}</a>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11" v-text="noData"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="block" v-if="isMobile === 'pc'">
        <pagination
          v-show="total > 0"
          :total="total"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :page.sync="page"
          :limit.sync="limit"
          @pagination="orderData"
        />
      </div>
      <div class="block" v-else>
        <pagination
          v-show="total > 0"
          :total="total"
          layout="total, prev, pager, next"
          background
          :page.sync="page"
          :limit.sync="limit"
          @pagination="orderData"
        />
      </div>-->
    </vuestic-widget>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { request } from "@/utils/utils.js";
import { formatDownloadResult as translateDownloadResult } from "@/utils/downloadResult.js";

export default {
  name: "PaymentOrderDetail",
  components: {
    Pagination,
  },
  data() {
    return {
      list: [
        {
          id: "15bab441-e79e-4254-96dd-03ca29ad6419",
          timeZone: "America/Sao_Paulo",
          createTime: "2021-08-06 02:27:44",
          updateTime: "2021-08-06 02:27:42",
          status: "download file create error",
          action: "",
        },
      ], // 请求回来填充表格的数据
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 10, // 默认一次显示10条数据
      noData: this.$t("t.noDataNoOrder"),
    }
  },
  mounted() {
    this.handleRefresh();
  },
  computed: {
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return "mobile";
      }
      return "pc";
    },
    tableHeaderList () {
      return [
        { label: "t.id", key: "id", id: 0 },
        { label: "t.timeZone", key: "timeZone", id: 1 },
        { label: "tables.listing.referenceDateTime", key: "createTime", id: 2 },
        { label: "tables.listing.updateTime", key: "updateTime", id: 3 },
        { label: "t.status", key: "status", id: 4 },
        { label: "t.action", key: "action", id: 5 },
      ]
    }
  },
  methods: {
    formatDownloadResult(result) {
      return translateDownloadResult(this, result)
    },
    orderData() {
      let start = this.page;
      let end = this.limit;
      let token = localStorage.getItem("Authorization");
    },
    handleRefresh() {
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
      let token = localStorage.getItem("Authorization");
      request({
        method: "post",
        url: `api/dashboard/waybill/download-list?access_token=${token}`,
        data: {},
      })
        .then((res) => {
          if (!res) {
            this.searching.close();
            return;
          }
          if (res.data.code == 20000) {
            this.list = [];
            this.total = 0;
            this.noData = this.$t("t.noData");
            setTimeout(() => {
              this.searching.close();
            }, 200);
            return;
          }
          this.list = res.data.data;
          this.total = res.data.data.length;
          setTimeout(() => {
            this.searching.close();
          }, 800);
        })
        .catch((err) => {
          this.searching.close();
        });
    },
    timeZoneValue(value) {
      if (!value) return ""
      let condition = JSON.parse(value);
      let conditionBean = {
        'Etc/GMT+3':'America/Sao_Paulo',
        'Etc/GMT':'Etc/GMT',
        'Etc/GMT-8':'Asia/Shanghai',
        'Etc/GMT+6':'America/Mexico_City'
      };
      if (condition.zone_id) {
        return conditionBean[condition.zone_id]
      } else {
        return ""
      }
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  }
}
</script>
<style lang="scss" scoped>
  #waybillDownload .table th {
    text-align: center;
  }
  #waybillDownload .table td {
    text-align: center;
  }
  #waybillDownload .table thead th {
    width: 300px;
  }
</style>
